module.exports = __webpack_public_path__ + "static/media/play_next.5ed78da7.svg";